import React from 'react';
import FoodCalorieInsights from './FoodCalorieInsights';

function App() {
  return (
    <div className="App">
      <FoodCalorieInsights />
    </div>
  );
}

export default App;
